import * as React from "react";
import {BoardEntry, JourneyStop} from "../controllers/model/api";
import DepartureEntryComponent from "./DepartureEntryComponent";
import GlobalConfiguration from "../controllers/model/GlobalConfiguration"
import "../scss/departure.scss"
import "../scss/message.scss"
import { MessageComponent } from "./MessageComponent";
import { HelperFunctions } from "../util/HelperFunctions";

export interface DepartureProps {
	departure: BoardEntry;
	backgroundColor: string;
	fontcolor?: string;
	stationInfoLine?: string;
}

export class DepartureComponent extends React.Component<DepartureProps, {}> {
	//#region Render
	public render() {
		if (this.props.stationInfoLine !== undefined && this.props.stationInfoLine !== "" && this.props.stationInfoLine !== null) {
			return (
				<div className="departure" style={{
					backgroundColor: this.props.backgroundColor, width: "100%"
				}}>
					<MessageComponent content={this.props.stationInfoLine} width={"100vw"} fontColor="#ba4040"></MessageComponent>
				</div>
			);
		}
		else {
			let borderStyle: any = "none";
			let borderWidth = "0px";
			let bordercolor = "transparent";

			if (this.props.backgroundColor !== "white" && this.props.backgroundColor !== "#D3D3D3") {
				borderStyle = "solid"
				bordercolor = "black";
				borderWidth = "1px";
			}
			return (
				<div className="departure" style={{
					backgroundColor: this.props.backgroundColor, color: this.props.fontcolor,
					borderTopStyle: borderStyle, borderTopColor: bordercolor, borderTopWidth: borderWidth
				}}>

					{GlobalConfiguration.Config.map((item, i) => {
						return this.renderCells(item,i);
					})}
				</div>
			);
		}
	}
	renderCells(item: any,i:number) {
		if (item.columnname === "Time"){
			return (<DepartureEntryComponent key={i}
				content= {this.props.departure.time}
				width={item.width} textAlign={item.textAlignment}></DepartureEntryComponent>)
			}
		if (item.columnname === "Estimated") {
			let fontColor = "";
			let content= "";
			if(GlobalConfiguration.showRealtime){
				let departure = Date.parse(this.props.departure.date + ":" + this.props.departure.time);
				let estimated = Date.parse(this.props.departure.date + ":" + this.props.departure.timeProg);
				fontColor = HelperFunctions.getDelayColorIndicator(departure, estimated);
				fontColor = this.getCorrectForegroundColor(fontColor);
				content = this.props.departure.timeProg;
			}
			else{
				fontColor = this.getCorrectForegroundColor("#ba4040");
				if (HelperFunctions.checkForNullOrEmpty(this.props.departure.timeProg)){
					if( this.props.departure.timeProg !==  this.props.departure.time)
						content = this.props.departure.timeProg;
				}
			}
			return (
				<DepartureEntryComponent key={i}
					content={content}
					width={item.width} textAlign={item.textAlignment} color={fontColor}></DepartureEntryComponent>)
		}
		if (item.columnname === "Platform")
			return (<MessageComponent key={i} content={this.props.departure.plattform} width={item.width} textAlign={item.textAlignment}></MessageComponent>)
		if (item.columnname === "Line"){
			var content = this.props.departure.line;
			var smallerContent = "";
			[content,smallerContent] = this.getLineContent(content);
			return (<DepartureEntryComponent key={i} content={content} smallercontent={smallerContent} width={item.width} textAlign={item.textAlignment}></DepartureEntryComponent>)
		}
		if (item.columnname === "Direction")
			return (<MessageComponent key={i} content={this.props.departure.direction} width={item.width} textAlign="left"></MessageComponent>)
		if (item.columnname === "VIAText") {
			var info = this.props.departure.infoLong;
			//var info = "Ich bin eine scrollende infoline";
			if(info.length === 0 || info === "")
				info = this.props.departure.infoShort;
			if(info.length !== 0 && info !== ""){
				let fontColor = "#ba4040"
				fontColor = this.getCorrectForegroundColor(fontColor);
				return (<MessageComponent key={i} content={info} width={item.width} fontColor={fontColor}></MessageComponent>)
			}
			let stops: string = "";
			if (this.props.departure.stops !== undefined)
				stops = this.parseStops(this.props.departure.stops.entries);
			return (<DepartureEntryComponent key={i} lineHeight="1.6rem" content={stops} width={item.width} textAlign={item.textAlignment} fontsize="1.5rem"></DepartureEntryComponent>)
		}
	}
	//#endregion
	
	//#region Util
	getLineContent(pLine:string){
		var splitted = null;
		if(pLine.includes(" ")){
			 splitted = pLine.split(" ");
			 return [splitted[0], splitted[1]]; 
		}
		return [pLine,""];
	}
	parseStops(items: JourneyStop[]) {
		var combinedStops = items.map(s => s.name);
		return combinedStops.filter((n, i) => combinedStops.indexOf(n) === i).join(" ~ ");
	}
	getCorrectForegroundColor(fontcolor : string) {
		if (this.props.backgroundColor === "#ba4040")
			return "white";
		else if(this.props.backgroundColor === "#ffff00")
			return "black";
		else
			return fontcolor;
	}
	//#endregion
}

export default DepartureComponent;